define((require) => {
    "use strict";

    const {find} = require("underscore");

    const BundleStrategies = {
        Standard: {
            name:        "Standard",
            isBundled:   false,
            description: "Standard bundle strategy. This is the default bundling strategy for all customers."
        },
        Channels: {
            name:        "Channels",
            isBundled:   true,
            description: "Channels bundle strategy - will bundle the channel configuration together with the channels.js code"
        },
        ChannelsAndLibs: {
            name:        "ChannelsAndLibs",
            isBundled:   true,
            description: `Channels and preloaded libs bundle strategy - will bundle the channel configuration together
with any external libs available (for now, only Piwik) and channels js.code`
        }
    };

    /**
     * Enumeration representing the bundle strategies <tt>value</tt> is equal
     * to <tt>companySettings.get("bundleStrategy")</tt>.
     *
     * @author avi
     */
    return {
        STANDARD:          BundleStrategies.Standard,
        CHANNELS:          BundleStrategies.Channels,
        CHANNELS_AND_LIBS: BundleStrategies.ChannelsAndLibs,

        all: [BundleStrategies.Standard, BundleStrategies.Channels, BundleStrategies.ChannelsAndLibs],

        fromValue(name) {
            return find(this.all, (item) => item.name === name);
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/data/BundleStrategy.js